export const formatCapacityMbps = (mbps: number | null | undefined) => {
  if (!Number.isFinite(mbps) || !mbps || mbps <= 0) return '—';
  return mbps >= 10 ? `${mbps.toFixed(1)} Mbps` : `${mbps.toFixed(2)} Mbps`;
};

export const formatUtilization = (value: number | null | undefined) => {
  if (!Number.isFinite(value)) return '—';
  return `${(Math.max(0, value as number) * 100).toFixed(0)}%`;
};

// This file will contain helper functions for the presentation components.


export const formatAge = (valueMs: number | undefined) => {
    if (!Number.isFinite(valueMs)) return '—';
    const seconds = Math.max(0, Math.round((Date.now() - (valueMs as number)) / 1000));
    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.round(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.round(hours / 24);
    return `${days}d ago`;
};

export const formatRangeLabel = (seconds: number) => {
    if (!Number.isFinite(seconds) || seconds <= 0) return '—';
    const minute = 60;
    const hour = 60 * minute;
    const day = 24 * hour;
    const year = 365 * day;
    if (seconds >= year && seconds % year === 0) return `${Math.round(seconds / year)}y`;
    if (seconds >= day && seconds % day === 0) return `${Math.round(seconds / day)}d`;
    if (seconds >= hour) return `${Math.round(seconds / hour)}h`;
    return `${Math.round(seconds / minute)}m`;
};

export const formatValue = (
  value: number | null | undefined,
  unit?: string,
  precision = 2
) => {
  if (!Number.isFinite(value) || value === null) return '—';
  const normalizedUnit = (unit ?? '').toLowerCase();
  if (normalizedUnit.includes('bps')) {
    const mbps = value / 1_000_000;
    if (!Number.isFinite(mbps) || mbps <= 0) return '—';
    return mbps >= 10 ? `${mbps.toFixed(1)} Mbps` : `${mbps.toFixed(2)} Mbps`;
  }
  if (normalizedUnit.includes('pps')) {
    if (value >= 1000) return `${(value / 1000).toFixed(1)}k pps`;
    return `${value.toFixed(1)} pps`;
  }
  if (normalizedUnit.includes('error') || normalizedUnit.includes('discard')) {
    return `${Math.round(value)} ${unit}`;
  }
  if (normalizedUnit.includes('count')) {
    return `${Math.round(value)}${unit ? ` ${unit}` : ''}`;
  }
  return `${value.toFixed(precision)}${unit ? ` ${unit}` : ''}`;
};

export const formatSeriesValue = formatValue;
